<!--
 * @Author: zxf
 * @Date: 2023-10-16 15:19:15
 * @LastEditors: zxf
 * @LastEditTime: 2023-12-23 17:02:33
 * @Description: 今日火警
-->
<template>
  <div class="u-fire-contains">
    <div class="u-fire-today">
      <img
        id="todoy"
        src="/images/monitor/hjSanjiao.png"
      >
      <div style="margin-left: 6px;">
        <span class="u-fire-today_num">{{ hjxxInfo.jrhj?hjxxInfo.jrhj:(hjxxInfo.jthj?hjxxInfo.jthj:0) }}</span>
        <span class="u-fire-today_label">今日报警</span>
      </div>
    </div>
    <div class="u-fire-circle">
      <div class="u-fire-wb">
        <div style="margin-left: 6px;">
          <span class="u-fire-circle__num">{{ hjxxInfo.wbhj?hjxxInfo.wbhj:0 }}</span>
          <span class="u-fire-circle__label">误报报警</span>
        </div>
      </div>
      <div class="u-fire-zs">
        <div style="margin-left: 6px;">
          <span class="u-fire-circle__num">{{ hjxxInfo.zshj?hjxxInfo.zshj:0 }}</span>
          <span class="u-fire-circle__label">真实报警</span>
        </div>
      </div>
      <!-- <div class="u-fire-wbsl">
        <div style="margin-left: 4px;">
          <span class="u-fire-circle__num">{{ hjxxInfo.zshj?hjxxInfo.zshj:0 }}</span>
          <span class="u-fire-circle__label">维保数量</span>
        </div>
      </div> -->
      <div class="u-fire-dqrcs">
        <div style="margin-left: 6px;">
          <span class="u-fire-circle__num">{{ hjxxInfo.dqrhj?hjxxInfo.dqrhj:hjxxInfo.dqrcs?hjxxInfo.dqrcs:0 }}</span>
          <span
            style="width: 67px;"
            class="u-fire-circle__label"
          >待确认报警</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TodayFire',
  props: {
    hjxxInfo: {
      type: Object,
      default: () => { return null; }
    }
  }
};
</script>

<style scoped lang="scss">
.u-fire-contains{
  height: 220px;
  background: url(/images/monitor/todayFire.png) no-repeat center center;
}

.u-fire-today{
  display: flex;
  position: relative;
  top: 44px;
  left: 34%;

  &_label{
    display: block;
    width: 56px;
    height: 12px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-size: 14px;
    font-weight: 700;
    line-height: 12px;
    color: #66F9FF;
    text-align: center;
  }

  &_num{
    padding-left: 4px;
    font-family: PangMenZhengDao;
    font-size: 22px;
    line-height: 28px;
    color: #FFF;
    text-align: center;
  }
}

.u-fire-circle{
  position: relative;
  top: 56px;

  &__num{
    display: block;
    width: 50px;
    height: 50px;
    font-family: PangMenZhengDao;
    font-size: 16px;
    line-height: 50px;
    letter-spacing: 0;
    color: #3DFBFF;
    text-align: center;
    background: url(/images/monitor/hjYuan.png) no-repeat;
  }

  &__label{
    display: block;
    width: 58px;
    height: 28px;
    margin-top: 6px;
    font-family: AlibabaPuHuiTi_2_55_Regular;
    font-size: 12px;
    font-weight: 400;
    line-height: 28px;
    color: #FFF;
    text-align: center;
    background: url(/images/monitor/hjLabel.png) no-repeat left center;
  }
}

.u-fire-wb{
  position: absolute;
  left: 10%;
}
.u-fire-zs{
  position: absolute;
  top: 12px;
  left: 40%;
}
.u-fire-wbsl{
  position: absolute;
  top: 12px;
  left: 50%;
}

.u-fire-dqrcs{
  position: absolute;
  top: 2px;
  left: 70%;
}
</style>
